export default __webpack_public_path__ + "static/media/architectBg.28684b6f.png";